import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import Logger from "dce-logger/lib/logger/Logger";

import Dialog from "./Dialog";
import DceAjaxResponse from "dce-ajax/lib/ajax/DceAjaxResponse";
import DropzoneLoader from "../dropzone/internal/DropzoneLoader";
import {InternalDropzoneOptions} from "../dropzone/internal/InternalDropzoneOptions";
import {I18n} from "../../../../dce-i18n/lib";

interface FileBrowserDialogProps {
}

@Dce("FileBrowserDialog")
export default class FileBrowserDialog extends DceComponent<FileBrowserDialogProps> {

    protected logger = Logger.of("FileBrowserDialog");

    private block: JQuery<HTMLElement>;

    private dialog: Dialog;
    private uploader: JQuery<HTMLElement>;
    private dropzone: Dropzone;


    constructor(elem: DceHTMLElement, props: FileBrowserDialog) {
        super(elem, props);
        this.block = $(elem);

        this.block.on('click', '.entity', (e) => {
            this.entityClicked(e);
        });

        this.setupUploader();
    }

    public cancel(){
        this.setupDialog();
        this.dialog.setForm(false, null);
        this.dialog.close();
    }

    public accept(){
        this.setupDialog();
        this.dialog.close();
    }

    private setupUploader(){
        this.uploader = this.block.find('div[data-role="uploader"]');

        let previewTpl = this.uploader.find('.upload-item').html()
        let previewCont = this.uploader.find('.upload-list')[0];

        let url = this.uploader.data('url');
        if(!url){
            url = '/file_browser/upload';
        }

        DropzoneLoader.load().then(Dropzone_ => {

            let options:InternalDropzoneOptions = {
                url: url,
                createImageThumbnails: false,
                previewTemplate: previewTpl,
                previewsContainer: previewCont,
                hiddenInputContainer: this.elem,
                uploadMultiple: false,
                withCredentials: true,

                //dzielenie na kawałki po 2MB
                chunking: true
            };

            if (I18n.has('dropzoneI18N')) {
                options = {
                    ...options,
                    ...I18n.get('dropzoneI18N')
                }
            }

            // @ts-ignore
            this.dropzone = new Dropzone_(this.uploader.find('.dropzone')[0], options);

            this.dropzone.on('complete', file => {
                this.uploadComplete(file);
            });

        })

    }


    private uploadComplete(file:Dropzone.DropzoneFile){

        if(file.status == 'success'){

            var jsonResp = JSON.parse(file.xhr.response);

            if(jsonResp.hasOwnProperty('response')){

                var html = jsonResp['response'].replace('{{form}}', "");

                this.block.find('.files-list').prepend(
                    $(html)
                );

            }

            setTimeout(function () {
                $(file.previewElement).slideUp(200);
            }, 800);

        }
    }

    private setupDialog(){
        if(null == this.dialog){
            if(this.elem.ext.hasComponent('Dialog')){
                this.dialog = this.elem.ext.getComponent('Dialog') as Dialog;
            }
        }

        if(null == this.dialog){
            throw new Error("FileBrowserDialog requires Dialog component on same element.")
        }
    }

    public entityClicked(e: JQuery.TriggeredEvent){
        e.preventDefault();

        this.setupDialog();

        let target = e.target as HTMLElement;
        let targetBlock = $(target);

        this.logger.debug("target", target);
        if(!targetBlock.hasClass('entity')){
            targetBlock = targetBlock.closest('.entity');
        }

        if(!targetBlock.hasClass('selected')){

            targetBlock.parent('div').find('.entity.selected').removeClass('selected');

            this.logger.debug("Parent", targetBlock.parent('div'));

            targetBlock.addClass('selected');

            let resp: any = {};

            resp.data = {};
            resp.data.id = targetBlock.data('id');
            resp.data.src = targetBlock.data('src');
            resp.response = targetBlock.find('script[data-response]').text();

            this.logger.debug("Created response", resp);

            this.dialog.setForm(true, new DceAjaxResponse(resp, 200));
        }else{

            targetBlock.removeClass('selected');
            this.dialog.setForm(false, null);

        }

    }

}
